import React, { useState } from 'react';

import { Box, Button } from '@mui/material';

import OhsModuleHeader from 'global-components/register/OhsModuleHeader';

import FixedCusval from './FixedCusval';
import FixedCusvalInvalid from './FixedCusvalInvalid';
import FixedCusvalNullDefId from './FixedCusvalNullDefId';

function FixedCusvalUITestMain() {
  const [activeTab, setActiveTab] = useState(1);

  const tabs = [
    {
      id: 1,
      name: 'Default',
      component: <FixedCusval />,
    },
    {
      id: 2,
      name: 'Invalid Cusvals',
      component: <FixedCusvalInvalid />,
    },
    {
      id: 3,
      name: 'Cusvals With Null Cusval Def',
      component: <FixedCusvalNullDefId />,
    },
  ];

  return (
    <Box>
      <OhsModuleHeader title="Cusval (Fixed)" as="h3" />

      {/* Header */}
      <Box width="100%" display="flex" mb={4}>
        {tabs.map((tab) => {
          return (
            <Box mr={1}>
              <Button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                variant={activeTab === tab.id ? 'contained' : 'outlined'}
              >
                {tab.name}
              </Button>
            </Box>
          );
        })}
      </Box>

      {/* Content */}
      <Box width="100%">{tabs.find((tab) => tab.id === activeTab)?.component}</Box>
    </Box>
  );
}

export default FixedCusvalUITestMain;
